import { render } from "./EventStausWidget.vue?vue&type=template&id=1ec0562c&scoped=true"
import script from "./EventStausWidget.vue?vue&type=script&lang=js"
export * from "./EventStausWidget.vue?vue&type=script&lang=js"

import "./EventStausWidget.vue?vue&type=style&index=0&id=1ec0562c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec0562c"],['__file',"src/containers/widget/components/EventStausWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec0562c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec0562c', __exports__)) {
    api.reload('1ec0562c', __exports__)
  }
  
  module.hot.accept("./EventStausWidget.vue?vue&type=template&id=1ec0562c&scoped=true", () => {
    api.rerender('1ec0562c', render)
  })

}


export default __exports__